import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { IMAGES } from "@/lib/content";
import { Reveal, Overline } from "@/components/site/Reveal";

export default function About() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section id="about" data-testid="about-section" className="bg-[#F8FAFC] py-24 md:py-32">
      <div className="mx-auto grid max-w-[1400px] items-center gap-14 px-6 md:px-12 lg:grid-cols-2">
        <div ref={ref} className="relative order-2 h-[440px] overflow-hidden lg:order-1 md:h-[560px]">
          <motion.img
            src={IMAGES.passenger}
            alt="Sanwariya Elevator engineering"
            style={{ y, scale: 1.2 }}
            className="absolute inset-0 h-full w-full object-cover"
          />
          <div className="pointer-events-none absolute bottom-0 left-0 z-10 bg-[#D89A18] px-8 py-6">
            <div className="font-display text-4xl font-bold tracking-tighter text-[#0B3A82]">
              Jaipur
            </div>
            <div className="font-body text-xs uppercase tracking-[0.2em] text-[#0B3A82]/80">
              Rajasthan, India
            </div>
          </div>
        </div>

        <div className="order-1 lg:order-2">
          <Reveal>
            <Overline>About Us</Overline>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-5 font-display text-4xl font-bold leading-[1.05] tracking-tighter text-[#0B3A82] sm:text-5xl">
              A trusted elevator company, engineered for reliability.
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-6 font-body text-base leading-relaxed text-[#475569] md:text-lg">
              Sanwariya Elevator is a trusted elevator company based in Jaipur,
              Rajasthan. We specialize in Elevator Installation, Lift Repair,
              Annual Maintenance Contracts (AMC), Elevator Modernization and
              Technical Support.
            </p>
          </Reveal>
          <Reveal delay={0.3}>
            <p className="mt-4 font-body text-base leading-relaxed text-[#475569] md:text-lg">
              Our experienced professionals ensure quality workmanship, timely
              delivery and complete safety for every project — reliable
              solutions that meet the highest standards of safety and
              performance.
            </p>
          </Reveal>
          <Reveal delay={0.4}>
            <button
              data-testid="about-contact-btn"
              onClick={() =>
                document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" })
              }
              className="mt-8 inline-flex items-center gap-2 px-7 py-4 font-body text-sm font-semibold uppercase tracking-wider transition-all hover:gap-4"
              style={{ background: "#0B3A82", color: "#fff" }}
            >
              Work With Us
            </button>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
